import styled from 'styled-components'
import { TwoColumnFoodGridWithListBlockRecord } from '../../types'
import { Container } from '@/components/shared/Container'
import { TwoColumnFeatureCardWithListNoImage } from '@/blocks/TwoColumnFeatureCardWithListNoImage'
import React from 'react'

const StyledMainContainer = styled.section`
  padding: 72px 0 64px 0;
  text-align: center;
  background-color: ${(p) => p.theme.v2.surface.white};

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    padding: 80px 100px 64px 100px;
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    padding: 80px 0px 40px 0px;
  }
`

const StyledHeading = styled.div`
  margin-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .pre-title {
    font-size: ${(p) => p.theme.v2.typography.body.m.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.m.lineHeight};
    margin-bottom: 8px;
  }

  h2 {
    font-size: ${(p) => p.theme.v2.typography.display.xxs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.display.xxs.lineHeight};
    font-family: ${(p) => p.theme.v2.font.nantes};
    color: ${(props) => props.theme.v2.onSurface.text};
    margin: 8px 0 0;
    @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
      font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
    }
    @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
      margin: 0 24px;
    }
  }

  p {
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    color: ${(props) => props.theme.v2.onSurface.subduedText};
    font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    width: 40vw;
    margin: 16px 0 0;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    margin-bottom: 32px;
    p {
      width: 50vw;
      font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
      line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
    }
  }
  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    p {
      width: 70vw;
    }
  }
`

const StyledGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  gap: 40px;

  .list-item {
    margin: 8px 0;
    width: 100%;
    justify-content: center;
  }

  .list-image {
    max-width: 64px;
    height: 64px;
    margin-right: 8px;
  }
  .text-with-icon {
    margin-top: 8px;
  }

  .text-with-icon .icon {
    width: 41px;
    height: 28px;
  }

  .text-with-icon p {
    margin: 4px 0 0 8px;
    font-family: ${(p) => p.theme.v2.font.lotaGrotesqueLight};
    font-size: ${(p) => p.theme.v2.typography.body.xs.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.xs.lineHeight};
  }
  h3 {
    margin-top: 0;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 24px;
  }
`

type TwoColumnFoodGridWithListBlockProps = {
  content: TwoColumnFoodGridWithListBlockRecord
}
export const TwoColumnFoodGridWithList = ({ content }: TwoColumnFoodGridWithListBlockProps) => {
  const { icon, preTitle, title, description, cards } = content
  return (
    <StyledMainContainer className="two-column-food-grid-with-list">
      <Container>
        {icon && <img style={{ margin: 'auto' }} width="72px" src={icon.url} alt={icon.alt} className="icon" />}
        <StyledHeading>
          {preTitle && <p className="pre-title">{preTitle}</p>}
          {title && <h2>{title}</h2>}
          {description && <p>{description}</p>}
        </StyledHeading>

        <StyledGrid>
          {cards.map((card) => {
            const { id, title, listContent, textBlock } = card
            return (
              <TwoColumnFeatureCardWithListNoImage
                key={id}
                title={title}
                listContent={listContent}
                textBlock={textBlock}
              />
            )
          })}
        </StyledGrid>
      </Container>
    </StyledMainContainer>
  )
}
